var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("burial.typeOfBurial.title") }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-radio-group", {
                    staticClass: "o-radio-button-group",
                    attrs: {
                      id: "radios1",
                      options: _vm.computedData.burialOptions,
                      name: "radioOpenions",
                      stacked: ""
                    },
                    model: {
                      value: _vm.localTypeOfBurial,
                      callback: function($$v) {
                        _vm.localTypeOfBurial = $$v
                      },
                      expression: "localTypeOfBurial"
                    }
                  }),
                  _vm._v(" "),
                  _c("b-form-textarea", {
                    staticClass: "o-form",
                    attrs: {
                      id: "other-burial-input",
                      type: "text",
                      required: "",
                      rows: 5,
                      "max-rows": 10,
                      placeholder: _vm.$t("burial.typeOfBurial.other"),
                      disabled: _vm.localTypeOfBurial != "Andere Art"
                    },
                    model: {
                      value: _vm.localOtherBurialText,
                      callback: function($$v) {
                        _vm.localOtherBurialText = $$v
                      },
                      expression: "localOtherBurialText"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("burial.typeOfGrave.title") }
          }),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-radio-group", {
                staticClass: "o-radio-button-group",
                attrs: {
                  id: "radios2",
                  options: _vm.computedData.graveOptions,
                  name: "radioOpenion2s",
                  stacked: ""
                },
                model: {
                  value: _vm.localTypeOfGrave,
                  callback: function($$v) {
                    _vm.localTypeOfGrave = $$v
                  },
                  expression: "localTypeOfGrave"
                }
              }),
              _vm._v(" "),
              _c("b-form-textarea", {
                staticClass: "o-form",
                attrs: {
                  id: "other-grave-input",
                  type: "text",
                  required: "",
                  rows: 5,
                  "max-rows": 10,
                  placeholder: _vm.$t("burial.typeOfGrave.other"),
                  disabled: _vm.localTypeOfGrave != "Andere Art"
                },
                model: {
                  value: _vm.localOtherGraveText,
                  callback: function($$v) {
                    _vm.localOtherGraveText = $$v
                  },
                  expression: "localOtherGraveText"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col save-button-div" },
        [
          _c("b-btn", { staticClass: "o-button", on: { click: _vm.save } }, [
            _vm._v(" " + _vm._s(_vm.$t("burial.saveButton")))
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-283dbc90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283dbc90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/BurialComponent.vue
// module id = null
// module chunks = 